import { rebaseSavedState } from "./rebase.js";
import { S, ui, initializeState, replaceState } from "../app/store.js";
let revision = 0,
  pending = false,
  saving = false,
  failed = false,
  activeSave = null;
export async function request(url, options = {}) {
  const response = await fetch(url, {
    credentials: "same-origin",
    ...options,
    headers: { "Content-Type": "application/json", ...options.headers },
  });
  const result = await response.json();
  if (!response.ok)
    throw new Error(
      result.error || result.message || "The request could not be completed.",
    );
  return result;
}
export async function loadWorkspace() {
  const data = await request("/api/workspace");
  revision = data.revision;
  initializeState(data.state, data.user.id);
  failed = false;
  return data;
}
export function setRevision(value) {
  revision = value;
}
export function scheduleSave() {
  pending = true;
  if (!saving && !failed) queueMicrotask(flushSave);
}
export function flushSave() {
  if (activeSave) return activeSave;
  if (failed || !pending) return Promise.resolve();
  activeSave = performSave().finally(() => {
    activeSave = null;
    if (pending && !failed) queueMicrotask(flushSave);
  });
  return activeSave;
}
export async function waitForWorkspaceSave() {
  do {
    await flushSave();
    if (failed)
      throw new Error(
        ui.syncStatus || "Save the user profile before sending its invitation.",
      );
  } while (pending || saving);
}
async function performSave() {
  saving = true;
  pending = false;
  ui.syncStatus = "Saving…";
  globalThis.dispatchEvent(new CustomEvent("milltech:sync"));
  try {
    const snapshot = structuredClone(S),
      result = await request("/api/workspace", {
        method: "PUT",
        body: JSON.stringify({ revision, state: snapshot }),
      });
    revision = result.revision;
    replaceState(
      pending ? rebaseSavedState(snapshot, S, result.state) : result.state,
    );
    ui.syncStatus = "All changes saved";
    ui.syncError = false;
    globalThis.dispatchEvent(new CustomEvent("milltech:render"));
  } catch (error) {
    failed = true;
    ui.syncStatus = "Save failed · " + error.message;
    ui.syncError = true;
  } finally {
    saving = false;
    globalThis.dispatchEvent(new CustomEvent("milltech:sync"));
  }
}
export function hasUnsavedChanges() {
  return pending || saving || failed;
}
export async function importWorkspace(state) {
  const result = await request("/api/import", {
    method: "POST",
    body: JSON.stringify({ state }),
  });
  revision = result.revision;
  replaceState(result.state);
  failed = false;
  return result;
}
